import { DEFAULT_ASSET_FIELDS } from '@/pages/Assets';
import type { AssetDTO } from '@/pages/Assets/Assets.types';
import { extractTagNames } from '@/pages/Assets/Assets.utils';

import type {
  AssetEditAddFormData,
  AssetValue,
  DefaultAssetFieldKey
} from './AssetAddEditDialog.types';

export const formatDefaultAssetValues = (
  selectedAsset: AssetDTO | null,
  type: 'add' | 'edit',
  organizationId?: number
) => {
  const defaultValues: AssetEditAddFormData = {};
  Object.entries(DEFAULT_ASSET_FIELDS).forEach(([field, value]) => {
    const typedField = field as DefaultAssetFieldKey;
    const typedValue = value as AssetValue;

    if (field === 'organization_id') {
      defaultValues.organization_id = organizationId;
    } else if (type === 'add') {
      (defaultValues[typedField] as any) = typedValue;
    } else if (type === 'edit') {
      // Handle special cases for tag fields that are now relationships
      if (field === 'user_tags') {
        (defaultValues[typedField] as any) = extractTagNames(
          selectedAsset?.user_tags
        );
      } else if (field === 'compliance_tags') {
        (defaultValues[typedField] as any) = extractTagNames(
          selectedAsset?.compliance_tags
        );
      } else {
        (defaultValues[typedField] as any) =
          (selectedAsset as any)?.[typedField] || typedValue;
      }
    }
  });

  return defaultValues;
};

export default formatDefaultAssetValues;
